import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { addOnsInitStepDeclaration } from "./Steps/AddOnsInitStep";

export const addOnsStartupStartupFlow = new FlowDefinition("AddOnsFlow");

addOnsStartupStartupFlow.addStep(addOnsInitStepDeclaration);

addOnsStartupStartupFlow.setStartStep("AddOnsInit_Step");

export const addOnsStartupStartupFlowDefinition = new StepDefinition({
    stepName: "AddOnsFlow",
    stepFlow: addOnsStartupStartupFlow,
    contextIsolation: false
})